import * as Yup from 'yup';
import { htmlStringHasText, createMediaSchema } from 'utils/sharedSchema.utils.js';

const moreInfoBlockSchema = Yup.object().shape({
  blockTitle: Yup.string().label('Block title').required().default(''),
  headline: Yup.string().label('Headline').required().default(''),
  description: Yup.string().label('Description').default('').test(htmlStringHasText),
  mediaItem: createMediaSchema('Please add an image or video.'),
});

export default moreInfoBlockSchema;
